/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();

/** @description import Global or some other files only if you need them */
import Cookies from 'js-cookie/src/js.cookie';

'use strict';
const ProductListing = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */
	$domFooter: $('.js-site-footer'),
	$domCompare: $('.js-product-listing__comapre-wrapper'),
	$domAddToList: $('.js-product-info-box__add-list-wrapper'),
	$domAddToListLink: $('.js-product-info-box__header-cta-btn'),
	$domAddToLinkClose: $('.js-product-info-box__add-list-close-btn'),
	$domAddListNameBtn: $('.js-product-info-box__add-list-cta'),
	$domSaveListNameBtn: $('.js-product-info-box__add-list-btn'),
	$domSideNav: $('.product-listing__side-nav'),
	$domSideNavItem: $('.js-product-listing__side-nav-item a'),
	$domSideNavWrapper: $('.js-product-listing__side-nav-item'),
	$domSideNavContainer: $('.product-listing__side-nav-container'),

	classComapreStick: 'product-listing__comapre-wrapper--stick',
	classAddToListActive: 'product-info-box__add-list-wrapper--active ',
	classAddListNameBtnActive: 'product-info-box__add-list-cta-wrapper--active',
	classSideNavItemActive: 'product-listing__side-nav-item-sub--active',
	classSideNavStick: 'product-listing__side-nav--fixed',
	classSideNavIconActive: 'product-listing__side-nav-item-arrow--active',
	classSideNavItemMenuActive: 'product-listing__side-nav-item--active',

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function () {
		this.addToList();
		this.closeList();
		this.addNewListName();
		this.elementOnScreen('.product-listing__side-nav', 'product-listing__side-nav--fixed', '.js-site-footer');
		this.appendSideNav();
		this.sideNav();
		this.elementOnScreen('.product-listing__alert', 'product-listing__alert--fixed', '.js-site-footer');

		if (!Cookies.get('showOnlyOne')) {
			$('.product-listing__alert').addClass('product-listing__alert--active');

			$('.js-product-listing__alert-close').on('click', function () {
				$('.product-listing__alert').hide();

				Cookies.set('showOnlyOne', 'showOnlyOne', {
					expires: 1
				});
			});
		}
	},

	elementOnScreen: ($element, $stickClass, $reference) => {
		/**
		 * @description Add class on element, based on if anchor(reference) element is in viewport.
		 * @example this.elementOnScreen(ProductListing.$domCompare, ProductListing.classComapreStick, ProductListing.$domFooter);
		 * @param {string} $element - Element you want to change
		 * @param {string} $stickClass - Class  you want to add to it, when reach reference element
		 * @param {string} $reference - Element that triggers class change, when reached.
		 */
		$(window).on('scroll', function() {
			const elementTop = $($reference).offset().top;
			const elementBottom = elementTop + $($reference).outerHeight();
			const elementHeight = $($reference).outerHeight();
			const viewportTop = $(window).scrollTop();
			const viewportBottom = viewportTop + $(window).height();

			if ((elementBottom - viewportBottom) <= elementHeight) {
				$($element).addClass($stickClass);
			} else {
				$($element).removeClass($stickClass);
			}
		});
	},

	addToList: () => {
		ProductListing.$domAddToListLink.each(function(e, el) {
			$(el).on('click', function() {
				$(this).parents('.js-product-info-box').find('.js-product-info-box__add-list-wrapper').addClass(ProductListing.classAddToListActive);
			});
		});
	},

	closeList: () => {
		ProductListing.$domAddToLinkClose.each(function(e, el) {
			$(el).on('click', function () {
				$(this).parents('.js-product-info-box').find('.js-product-info-box__add-list-wrapper').removeClass(ProductListing.classAddToListActive);
			});
		});
	},

	addNewListName: () => {
		ProductListing.$domAddListNameBtn.each(function(e, el) {
			$(el).on('click', function() {
				$(this).parents('.js-product-info-box__add-list-cta-wrapper').addClass(ProductListing.classAddListNameBtnActive);
			});
		});

		ProductListing.$domSaveListNameBtn.each(function(e, el) {
			$(el).on('click', function() {
				setTimeout(function() {
					$(this).parents('.js-product-info-box__add-list-cta-wrapper').removeClass(ProductListing.classAddListNameBtnActive);
				}, 300);
			});
		});
	},

	sideNav: () => {
		if ($(window).width() > 1024) {
			$(document).on('mouseenter', '.js-product-listing__side-nav', (e) => {
				$('body').css('overflow', 'hidden');
			});

			$(document).on('mouseleave', '.js-product-listing__side-nav-item', (e) => {
				const _self = $(e.currentTarget);
				$('body').css('overflow', 'auto');
				if (_self.hasClass(ProductListing.classSideNavItemMenuActive)) {
					_self.removeClass(ProductListing.classSideNavItemMenuActive);
				}
			});

			$(document).on('click', '.product-listing__side-nav-item-back', (event) => {
				event.stopPropagation();
				$('.js-product-listing__side-nav-item').removeClass(ProductListing.classSideNavItemMenuActive);
				$('body').css('overflow', 'auto');
			});
		}

		$(document).on('click', '.js-product-listing__side-nav-item', (e) => {
			const _self = $(e.currentTarget);
			if (!_self.hasClass(ProductListing.classSideNavItemMenuActive)) {
				$('.js-product-listing__side-nav-item').removeClass(ProductListing.classSideNavItemMenuActive);
				_self.addClass(ProductListing.classSideNavItemMenuActive);
				$('body').css('overflow', 'auto');
			} else {
				$('.js-product-listing__side-nav-item').removeClass(ProductListing.classSideNavItemMenuActive);
				$('body').css('overflow', 'auto');
			}
		});
	},

	appendSideNav: () => {
		$('.megamenu-dropdown__box').each(function(e, el) {
			const link = $(el).find('.megamenu-dropdown__box-title');
			const list = $(el).find('.megamenu-dropdown__box-lists');

			$('.js-product-listing__header-options--side-nav').append(`
				<option value='${link[0].text}'><a href='${link[0].href}'>${link[0].text}</a></option>
			`);

			list.each(function(n, subEl) {
				const subList = $(subEl).find('.megamenu-dropdown__box-list');

				subList.each(function(i, grandChild) {
					const ListTitleLink = $(grandChild).find('a');
					const ListTitleLinkHtml = `<a href="${ListTitleLink.attr('href')}">${ListTitleLink.text()}</a>`;

					if (ListTitleLink.length && subList.length) {
						$('.select-side-nav-dropdown .select2-results__options').append(
							`
								<li class="mm-sub-menu-item">
									${ListTitleLinkHtml}
								</li>
							`
						);
					}
				});
			});
		});
	},
};

export default ProductListing;
